<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="md:min-w-448 bg-white p-5 md:p-7 rounded-t-3xl md:rounded-3xl md:max-w-lg md:w-2/5"
    [style.z-index]="(index$ | async) + 50"
  >
    <h1
      class="text-neutral-800 font-brand font-bold text-28px pb-5"
      translate="group-payments.add-payment-modal.title"
    ></h1>
    <div class="pb-5">
      <ng-container *ngIf="userHasPaid$ | async">
        <div class="flex flex-col cursor-pointer text-neutral-600">
          <div class="py-4.5 flex justify-between items-center">
            <div class="w-full flex items-center justify-center justify-between">
              <div>
                <span class="text-xs pr-1.5">
                  <input
                    type="radio"
                    class="form-radio border-2 p-2.5 bg-none bg-primary-600 border-primary-600 m-1 shadow-custom border-neutral-400"
                    [checked]="true"
                  />
                </span>
                <span class="text-sm text-neutral-800">
                  {{ 'group-payments.add-payment-modal.pay-remaining-amount' | translate }}
                </span>
              </div>
              <div class="text-sm text-neutral-800">
                <app-price-atom
                  *ngIf="this.remainingAmount"
                  [size]="'SM'"
                  [amount]="this.remainingAmount"
                  [bold]="false"
                  format="true"
                ></app-price-atom>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!(userHasPaid$ | async)">
        <div *ngFor="let paymentMethod of paymentOptions">
          <div
            *ngIf="paymentMethod.mode !== paymentModalAmountModes.Remaining"
            class="flex flex-col cursor-pointer text-neutral-600"
          >
            <div
              class="py-4.5 flex justify-between items-center"
              (click)="changePaymentOption(paymentMethod)"
            >
              <div class="flex items-center">
                <div>
                  <span class="text-xs pr-1.5">
                    <input
                      type="radio"
                      [ngClass]="{
                        'p-2.5 bg-primary-600 border-primary-600 m-1 shadow-custom':
                          paymentMethod === selectedPaymentMethod,
                      }"
                      class="form-radio border-2 p-1.5 bg-none m-2 border-neutral-400"
                      [checked]="paymentMethod === selectedPaymentMethod"
                    />
                  </span>
                  <span class="text-sm text-neutral-800">
                    {{ 'group-payments.add-payment-modal.' + paymentMethod.label | translate }}
                  </span>
                  (<app-price-atom
                    *ngIf="paymentMethod.mode === paymentModalAmountModes.Own"
                    [size]="'SM'"
                    [amount]="this.ownAmount"
                    [bold]="false"
                    format="true"
                  ></app-price-atom>
                  <app-price-atom
                    *ngIf="paymentMethod.mode === paymentModalAmountModes.Full"
                    [size]="'SM'"
                    [amount]="this.remainingAmount"
                    [bold]="false"
                    format="true"
                  ></app-price-atom
                  >)
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="errorMessage">
      <p
        class="py-4 text-sm text-error-700 text-center"
        [translate]="errorMessage"
      ></p>
    </div>

    <app-button-atom
      size="L"
      [disabled]="disablePayment"
      [label]="'group-payments.add-payment-modal.continue-to-payment' | translate"
      type="primary"
      [full]="true"
      (click)="onSubmit()"
    >
    </app-button-atom>
  </div>
</div>
